function capitalizeString(string: string) {
  if (!string || typeof string !== 'string') return ''

  const trimmed = string.trim()

  if (!trimmed) return ''

  return trimmed[0].toUpperCase() + trimmed.slice(1)
}

export default capitalizeString
